import React from "react";
import { Circles } from "react-loader-spinner";
const LoaderComp = () => (
  <div className='loader-container'>
    <Circles ariaLabel='loading' color='#000000' height={40} width={40} />
  </div>
);

export default LoaderComp;
